<template>
    <div name="settlement" class="wrapper">
        <settlement-file-view 
            v-if="selectedSettlement"
            :settlement="selectedSettlement"
            @closeFileView="closeFileView"
        />
        <div class="page" v-else>
            <div class="button-header">
                <img @click="back" style="width: 22px; cursor: pointer;" src="../assets/arrow_back.png" />
                <span class="button-header-text">연말정산 명세서 보기</span>
            </div>
            <div class="select-header-bar" style="margin-top: 16px;">
                <span class="total-medical-count-text">전체 {{ diabetes_settlement.settlements.length }}</span>
                <small-select-box 
                    v-if="isSelect"
                    :options="options"
                    :selectedIndex="selectedIndex"
                    :placeHolder="''"
                    :title="'등록된 환자 목록'"
                    @select="selectProfile"
                />
            </div>
            <div class="settlement-info-banner">
                <span class="settlement-info-banner-text">• 본 서류는 연말정산 및 종합소득세 신고 시 의료기기 공제용으로 활용할 수 있습니다. </span>
                <span class="settlement-info-banner-text" style="margin-top: 10px;">• 전년도 서류는 매년 초부터 확인 및 다운로드 가능합니다.</span>
            </div>
            <div class="settlement-list-section" v-if="diabetes_settlement.settlements.length > 0">
                <div class="settlement-card" v-for="(settlement, index) in diabetes_settlement.settlements" @click="view(settlement)">
                    <div class="settlement-info-section">
                        <span class="settlement-info-text-year">발급일 {{ convertTimeToString(settlement.published_at) }}</span>
                        <span class="settlement-info-text-name" style="margin-top: 8px;">{{ settlement.name }} <span style="color: var(--Gray-50, #A3AAB6);"> | </span> {{ settlement.year }}년도 자료</span>
                    </div>
                    <img style="width: 28px;" src="../assets/settlement_right_arrow_icn.png" />
                </div>
            </div>
            <div class="no-medical-box" v-else style="margin-top: 16px;">
                <img style="width: 87.689px;" src="../assets/document.png" />
                <span class="no-medical-text">발행된 서류가 없습니다.</span>
            </div>
        </div>
    </div>
</template>

<script>
// 내역 가져오기 
import {mapState} from 'vuex';
import Constant from '@/constant';
import ErrorModal from '@/components/modals/ErrorModal';
import cookies from '@/utilities/cookie.js';
import convert from '@/utilities/convert.js'
import FileView from '@/components/organisms/contract/FileView';
import SmallSelectBox from '@/components/atoms/SmallSelectBox.vue';
import SettlementFileView from '@/components/organisms/contract/SettlementFileView';

export default {
    name: 'settlement',
    computed: mapState(['diabetes_profiles', 'diabetes_settlement']),
    components: {
        SmallSelectBox,
        SettlementFileView
    },
    data: function()
    {
        return {
            token: null,
            error: null,
            selectedHistory: null,
            select1List: [],
            select2List: [],
            select3List: [],
            options: ['모든 환자'],
            selectedIndex: 0,
            isSelect: false,
            selectedSettlement: null
        }
    },
    mounted: function()
    {
        this.topFunction();
        ChannelIO('shutdown')
        this.token = cookies.getLocalStorage("access_token");

        if(this.token === null || this.token === undefined || this.token === '')
        {
            this.token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'settlement'}})
        }
        else {
             this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                .then(() => {
                   
                    this.diabetes_profiles.forEach(data => {
                        this.options.push(data.profile.name)
                    });
                    this.isSelect = true;
                }) 
                .catch(() => {
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'info'}})
                })
            
                            // 유효성 체크    
        this.$store.dispatch(Constant.FETCH_YEAR_TAX, {profile_id: null, token: this.token})
            .then(() => {

            }) 
            .catch(() => {
                this.token = cookies.deleteLocalStorage("access_token");
                this.$router.push({path: '/', query: {returnUrl: 'settlement'}})
            })
        }
    },
    methods: {
        selectProfile: function(select)
        {
            this.selectedIndex = select;
            this.$store.dispatch(Constant.FETCH_YEAR_TAX, {profile_id: select === 0 ? null : this.diabetes_profiles[this.selectedIndex - 1].profile.id, token: this.token})
                .then(() => {

                }) 
                .catch(() => {
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'settlement'}})
                })
        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        back: function()
        {
            this.$router.push({path: '/home'})
        },
        convertTimeToString: function(time)
        {
            return convert.formatTimestamp(time)
        },
        view: function(settlement)
        {
            this.selectedSettlement = settlement
        },
        closeFileView: function()
        {
            this.selectedSettlement = null
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .page {
        width: 100%;
        background: #FFF;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 0 16px;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }

    .button-header {
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .button-header-text {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 16px;
    }
    .select-header-bar {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .total-medical-count-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 140% */
    }
    .settlement-info-banner {
        width: 100%;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        display: flex;
        flex-direction: column;
        padding: 20px 16px;
        box-sizing: border-box;
        margin-top: 16px;
    }
    .settlement-info-banner-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .settlement-list-section {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 16px;
    }
    .settlement-card {
        width: 100%;
        border-radius: 6px;
        border: 1px solid #E8EAEE;
        background: #FFF;
        box-sizing: border-box;
        padding: 20px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        cursor: pointer;
    }
    .settlement-info-section {
        display: flex;
        flex-direction: column;
    }
    .settlement-info-text-year {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .settlement-info-text-name {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .no-medical-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding-top: 80px;
    }
    .no-medical-text {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 24.5px; /* 136.111% */
        margin-top: 50px;
    }

</style>


// WEBPACK FOOTER //
// src/page/Settlement.vue